<div class="agpr-additionalRecipient">
    <div class="agpr-additionalRecipient-filterToolbar">
        <div class="agpr-additionalRecipient-filterToolbar-filterInput">
            <agpr-filter-dropdown
                [id]="'resultsFilters'"
                [showQuickFilter]="true"
                quickFilterPlaceholder="Discover.targeting.filter.email.placeholder"
                [ariaLabel]="'Discover.distribution.recipients.email.filterLabel' | localize"
                ariaDescribedBy="staffSearch.chips"
            ></agpr-filter-dropdown>
        </div>
        <agpr-sort-order
            id="additionalRecipientSortOrder"
            [isDisabled]="!results?.length"
            tooltip="Discover.targeting.tooltips.sort"
            optionKey="enumValue"
            optionLabel="displayString"
        ></agpr-sort-order>
    </div>
    <agpr-filter-chips
        class="agpr-additionalRecipient-filterChips"
        *ngIf="chipsVisible"
        id="staffSearch.chips"
    ></agpr-filter-chips>

    <div class="agpr-additionalRecipient-totalCount">
        <span class="agpr-additionalRecipient-totalCount-value">
                {{ totalResults || '0'}}
                <span class="agpr-additionalRecipient-totalCount-text">
                    {{'Common.other' | localize}}
                </span>
        </span>
        <agpr-minimal-paginator [isDisabled]="!totalResults"></agpr-minimal-paginator>
    </div>
</div>
